import { JANZU_URL } from "config/config";

export function generateImageUrl(imageQueryId: string | undefined, imageId?: string) {
  if (imageQueryId) {
    return `${JANZU_URL}device-api/v1/image-queries/${imageQueryId}/image`;
  }

  // avoid calling /api/vizproc/image endopint with an undefined imageId
  // because it will raise an exception
  if (imageId === undefined) {
    throw new Error("imageQueryId and imagedId cannot be both undefined.");
  }

  return `${JANZU_URL}api/vizproc/image/?id=${imageId}`; // Old URL
}
